export default __webpack_public_path__ + "static/media/Dheeraj Prasad.18124855.jpg";